import { createAsyncThunk } from "@reduxjs/toolkit";
import { parseErrorMessage } from "utils";

import { deleteStrategy, getStrategies } from "../service";

export const fetchStrategyList = createAsyncThunk("strategy/list", async () => {
  const response = await getStrategies();
  return response;
});

export const removeStrategy = createAsyncThunk(
  "strategy/delete",
  async (strategyId, thunkAPI) => {
    try {
      await deleteStrategy(strategyId);
      return strategyId;
    } catch (error) {
      const msg = parseErrorMessage(error);
      return thunkAPI.rejectWithValue({ error: msg });
    }
  }
);
